/**
 *  研发检索版，支持的搜索字段和原检索版不同
 */
import {
    get, cloneDeep, includes, map, remove, concat,
} from 'lodash';
import { SEARCH_FIELDS, SEARCH_FIELDS_US } from './fieldConfig';
import searchFieldsService from '../service/searchFieldsService';

/**
 * 不支持的字段
 */
const subRDFields = [
    // 诉讼
    { key: 'LITIGATION', type: 'Count' },
    { key: 'CASENO', type: 'Text' },
    { key: 'COURT', type: 'Text' },
    { key: 'JUDGE', type: 'Text' },
    { key: 'CHIEF_JUDGE', type: 'Text' },
    { key: 'PLAINTIFF', type: 'Text' },
    { key: 'DEFENDANT', type: 'Text' },
    { key: 'FILING_DATE', type: 'Date' },
    { key: 'VERDICT_DATE', type: 'Date' },
    { key: 'HEARING_DATE', type: 'Date' },
    { key: 'TRIAL_GRADE', type: 'Text' },
    { key: 'CASE_NATURE', type: 'Text' },
    { key: 'CASE_REGION', type: 'Text' },
    { key: 'CASE_TITLE', type: 'Text' },
    { key: 'CASE_FULL_TEXT', type: 'Text' },
    { key: 'LIT_CLOSEDT', type: 'Date' },
    { key: 'OUTCOME_JUDGEMENT', type: 'Text' },
    { key: 'OUTCOME_STATUS', type: 'Text' },
    { key: 'LITIGATION_COUNT', type: 'Count' },
    { key: 'CASE_DOC_TYPE', type: 'Text' },
    { key: 'COURT_GRADE', type: 'Text' },
    { key: 'VERDICT', type: 'Text' },
    { key: 'PARTY', type: 'Text' },
    { key: 'PARTY_AGENT', type: 'Text' },
    { key: 'PARTY_LAWFIRM', type: 'Text' },
    { key: 'AMOUNT_PLAINTIFF', type: 'Count' },
    { key: 'DAMAGES_AMOUNT', type: 'Count' },
    { key: 'FILING_YEAR', type: 'Date' },
    { key: 'LITIGATION_PRODUCT', type: 'Text' },

    // 许可
    { key: 'LICENSE', type: 'Count' },
    { key: 'LICENSOR', type: 'Text' },
    { key: 'LICENSEE', type: 'Text' },
    { key: 'LICNO', type: 'Text' },
    { key: 'EXCLUSIVITY', type: 'Text' },
    { key: 'LIC_EFDT', type: 'Date' },
    { key: 'LICENSE_COUNT', type: 'Count' },

    // 复审无效
    { key: 'REEXAMINVALID', type: 'Count' },
    { key: 'RI_APPLICANT', type: 'Text' },
    { key: 'RIDN', type: 'Text' },
    { key: 'RIIN', type: 'Text' },
    { key: 'RIDDT', type: 'Date' },
    { key: 'RIDTP', type: 'Text' },
    { key: 'RID', type: 'Text' },
    { key: 'RIDP', type: 'Text' },
    { key: 'RIDSM', type: 'Text' },
    { key: 'RILGS', type: 'Text' },
    { key: 'INVALID_COUNT', type: 'Count' },

    // 质押
    { key: 'PLEDGE', type: 'Count' },
    { key: 'PLEDGOR', type: 'Text' },
    { key: 'PLEDGEE', type: 'Text' },
    { key: 'PLEDGENO', type: 'Text' },
    { key: 'PLE_EFDT', type: 'Date' },
    { key: 'PLE_STAGE', type: 'Text' },
    { key: 'PLEDGE_COUNT', type: 'Count' },

];
/**
 * 新支持的字段（未来预留）
 */
const addRDFields = [

];

const generateRDFields = () => {
    const originFields = cloneDeep(SEARCH_FIELDS);
    remove(originFields, (field) => includes(map(subRDFields, 'key'), field.name));
    let newRDFields = originFields;
    if (addRDFields.length) {
        newRDFields = concat(newRDFields, addRDFields);
    }
    return newRDFields;
};

export const RD_SEARCH_FIELDS = generateRDFields();

export function getRDSearchFieldsByServiceArea(serviceArea) {
    // eslint-disable-next-line no-param-reassign
    serviceArea = serviceArea || get(window, 'zPREFACE.accountInfo.site_region', '').toLowerCase();
    let searchFields = RD_SEARCH_FIELDS;
    if (serviceArea === 'us' || serviceArea === 'eu') {
        searchFields = searchFields.concat(SEARCH_FIELDS_US);
    }
    searchFields = searchFields.concat(searchFieldsService.searchFields);
    return searchFields;
}

export default {
    RD_SEARCH_FIELDS,
    getRDSearchFieldsByServiceArea,
};
